export default __webpack_public_path__ + "static/media/TikTok_Settings_Final.1fe84168.jpeg";